var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-alert",
    { attrs: { id: "data-table-search-no-results", icon: "warning" } },
    [
      _vm._v(
        "\n  " +
          _vm._s(_vm.$t("tables.SearchMessageInitial")) +
          ' "' +
          _vm._s(_vm.search) +
          '"\n  ' +
          _vm._s(_vm.$t("tables.SearchMessageEnd")) +
          "\n"
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2bf5a786", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bf5a786","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Atoms/DataTableNoResults.vue
// module id = null
// module chunks = 